import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserRole } from 'src/common/models/user/user-role.enum';
import { DialogService } from '../../../../services/dialog/dialog.service';
import { SubscriptionInfo } from '../../../../common/models/payment/subscription-info';
import { ConfigService } from 'src/services/config.service';
import { PriceLabel } from 'src/common/models/price/price';
import { Parameter } from 'src/app/admin-pages/parameters/core/parameter';
import { finalize } from 'rxjs';

@Component({
  selector: 'psc-plan-selection',
  templateUrl: './plan-selection.component.html'
})
export class PlanSelectionComponent implements OnInit {

  loading: boolean = false;
  plans = [
    {
      role: UserRole.ROLE_BUSINESS,
      translationGroup: 'business',
      price: 0,
      currency: 'EUR',
    },
    {
      role: UserRole.ROLE_BUSINESS_PLUS,
      translationGroup: 'business_plus',
      price: 0,
      currency: 'EUR',
    }
  ];

  @Input() subscription: SubscriptionInfo;

  protected readonly UserRole = UserRole;
  @Output() planSelected: EventEmitter<UserRole> = new EventEmitter<UserRole>();

  constructor(
    private dialogService: DialogService,
    private configService: ConfigService
  ) {
  }

  ngOnInit(): void {
    this.loading = true;
    const labels = {
      [PriceLabel.BUSINESS_SUBSCRIPTION_PACKET_COST]: (value: number) => this.plans[0].price = value,
      [PriceLabel.BUSINESS_PLUS_SUBSCRIPTION_PACKET_COST]: (value: number) => this.plans[1].price = value
    };

    this.configService.getPriceParams().pipe(
      finalize(() => {
        this.loading = false;
      }),
    ).subscribe((priceParams: Parameter[]) => {
      priceParams.forEach(price => {
        const mappingFunction = labels[price.label];
        if (mappingFunction) {
          mappingFunction(price.value);
        }
      });
    });
  }

  choosePlan(role: UserRole) {

    this.dialogService.openConfirmDialog(() => {
      this.planSelected.emit(role);
    });
  }
}
